import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

// Fase 32: collectors need to know when the admin paused the streak engine
// so the weekly risk banner and failure-state banner can disappear. The
// flag lives in the admin-only `config` collection; we read it through the
// public endpoint that whitelists `streak_engine_enabled` for any auth user.
// Default true on transient errors so we never hide a real banner because
// of a flaky request.
export function useStreakEngineEnabled(): boolean {
  const isAuth = !!pb.authStore.token;
  const { data } = useQuery({
    queryKey: ['streak_engine_enabled'],
    queryFn: async (): Promise<boolean> => {
      try {
        const r = await pb.send('/api/config/public', { method: 'GET' });
        const v = r['streak_engine_enabled'];
        if (v === false || v === 'false') return false;
        return true;
      } catch {
        return true;
      }
    },
    enabled: isAuth,
    staleTime: 10_000,
    retry: 1,
  });
  return data ?? true;
}
